import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Header, Divider } from 'semantic-ui-react';
import { DateLabel, Score, Table } from 'components';
import { translateBenchmarkHeading } from '../../../../utils/helpers';
import { translation } from '../../../Translation/scorecard';

@connect((state) => ({
  user_region: state.Storage.user_region || 'CA',
  french: state.Storage.language === 'fr',
}))
export default class Performance extends Component {
  getPercent = (num) => (!num ? '-' : `${(num * 100).toFixed(2)} %`);

  formatNum = (num) => (!num ? '-' : num.toFixed(2));

  parseDate = (portfolio, short) => {
    const { french } = this.props;
    const init = portfolio.init_date.split('-');
    const end = portfolio.end_date.split('-');
    const language = french ? 'fr' : 'en';

    return short
      ? `${translation[language].MONTH[[end[1]]]} ${end[0]}`
      : `${translation[language].MONTH[init[1]]} ${init[0]} to ${
          translation[language].MONTH[end[1]]
        } ${end[0]}`;
  };

  render() {
    const { analytics } = this.props;
    const { benchmark, data } = analytics;
    const { french } = this.props;
    const language = french ? 'fr' : 'en';

    const split =
      data.portfolio && data.portfolio.end_date
        ? data.portfolio.end_date.split('-')
        : null;

    const months = french
      ? {
          '01': 'Janvier',
          '02': 'Février',
          '03': 'Mars',
          '04': 'Avril',
          '05': 'Mai',
          '06': 'Juin',
          '07': 'Juillet',
          '08': 'Août',
          '09': 'Septembre',
          10: 'Octobre',
          11: 'Novembre',
          12: 'Décembre',
        }
      : {
          '01': 'January',
          '02': 'February',
          '03': 'March',
          '04': 'April',
          '05': 'May',
          '06': 'June',
          '07': 'July',
          '08': 'August',
          '09': 'September',
          10: 'October',
          11: 'November',
          12: 'December',
        };
    const date = split
      ? french
        ? `En date du ${months[split[1]]} ${split[2]}, ${split[0]}`
        : `As of ${months[split[1]]} ${split[2]}, ${split[0]}`
      : 'N/A';

    return (
      <Container>
        <Score
          name="Performance "
          score={`${data.score.Performance[benchmark][0]}%`}
          grade={data.score.Performance[benchmark][1]}
          portfolio={data.portfolio}
          pdf
          extraInfo={
            french
              ? 'Par rapport à votre indice de référence'
              : 'Relative to your benchmark'
          }
        />
        <p>{translation[language].PERFORMANCE_DESCRIPTION_1}</p>
        {french ? (
          <p>
            Si vous investissez dans des titres qui comportent un certain niveau
            de risque (qu’il soit élevé ou faible), les ratios ajustés au risque
            sont des mesures plus appropriées de la performance, car les
            rendements ne sont pas garantis. Il va sans dire que des ratios
            élevés en particulier par rapport à l’indice de référence de votre
            portefeuille, sont préférables
          </p>
        ) : (
          <p>
            As long as you invest in securities that involve some level of risk
            - however high or low – the risk adjusted ratios are more
            appropriate measures of performance, because the returns are not
            guaranteed. Needless to say, the <b>higher</b> the ratios,
            especially relative to your portfolio's benchmark, the <b>better</b>
            .
          </p>
        )}

        <Header>
          <Header.Content>
            {translation[language].KEY_STATISTICS}
          </Header.Content>
          <Header.Subheader>
            <DateLabel
              str={`${this.parseDate(data.portfolio)} (${
                translation[language].INCLUSIVE
              })`}
            />
          </Header.Subheader>
        </Header>

        <Divider />

        <Table basic textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={3} />
              <Table.HeaderCell>
                {translation[language].ANNUALIZED_RETURN}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].SHARPE_RATIO}&nbsp;
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].ROY_SAFETY}&nbsp;
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].SORTINO_RATIO}&nbsp;
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row positive>
              <Table.Cell width={3}>
                {translation[language].MY_PORTFOLIO}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios.portfolio.annualizedRet)}
              </Table.Cell>
              <Table.Cell>
                {this.formatNum(data.fratios.portfolio.sharpe)}
              </Table.Cell>
              <Table.Cell>
                {this.formatNum(data.fratios.portfolio.roys)}
              </Table.Cell>
              <Table.Cell>
                {this.formatNum(data.fratios.portfolio.sortino)}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={3}>
                {translateBenchmarkHeading(
                  data.fratios[benchmark].name,
                  french
                )}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios[benchmark].annualizedRet)}
              </Table.Cell>
              <Table.Cell>
                {this.formatNum(data.fratios[benchmark].sharpe)}
              </Table.Cell>
              <Table.Cell>
                {this.formatNum(data.fratios[benchmark].roys)}
              </Table.Cell>
              <Table.Cell>
                {this.formatNum(data.fratios[benchmark].sortino)}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>

        <Header>
          <Header.Content>
            {`${translation[language].ANNUALIZED_RETURNS} - ${translation[language].TOTAL_PORTFOLIO}`}
          </Header.Content>
          <Header.Subheader>
            <DateLabel str={`${date}`} />
          </Header.Subheader>
        </Header>

        <Divider />

        <Table basic textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={3} />
              <Table.HeaderCell>{translation[language].YTD}</Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].ONE_YEAR}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].THREE_YEAR}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].FIVE_YEAR}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].SEVEN_YEAR}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].TEN_YEAR}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            <Table.Row positive>
              <Table.Cell width={3}>
                {translation[language].MY_PORTFOLIO}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios.portfolio.retYTD)}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios.portfolio.ret1)}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios.portfolio.ret3)}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios.portfolio.ret5)}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios.portfolio.ret7)}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios.portfolio.ret10)}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={3}>
                {translateBenchmarkHeading(
                  data.fratios[benchmark].name,
                  french
                )}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios[benchmark].retYTD)}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios[benchmark].ret1)}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios[benchmark].ret3)}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios[benchmark].ret5)}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios[benchmark].ret7)}
              </Table.Cell>
              <Table.Cell>
                {this.getPercent(data.fratios[benchmark].ret10)}
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>

        <Header>
          <Header.Content>
            {`${translation[language].ANNUALIZED_RETURNS} - ${translation[language].TOP_10_HOLDINGS}`}
          </Header.Content>
          <Header.Subheader>
            <DateLabel str={`${date}`} />
          </Header.Subheader>
        </Header>

        <Table basic textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={3} />
              <Table.HeaderCell>{translation[language].YTD}</Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].ONE_YEAR}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].THREE_YEAR}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].FIVE_YEAR}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].SEVEN_YEAR}
              </Table.HeaderCell>
              <Table.HeaderCell>
                {translation[language].TEN_YEAR}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data.holdingTrailingRets &&
              data.holdingTrailingRets.slice(0, 10).map((row, index) => (
                <Table.Row positive={index % 2 === 0}>
                  <Table.Cell width={3}>{row.ticker}</Table.Cell>
                  <Table.Cell>{this.getPercent(row.retYTD)}</Table.Cell>
                  <Table.Cell>{this.getPercent(row.ret1)}</Table.Cell>
                  <Table.Cell>{this.getPercent(row.ret3)}</Table.Cell>
                  <Table.Cell>{this.getPercent(row.ret5)}</Table.Cell>
                  <Table.Cell>{this.getPercent(row.ret7)}</Table.Cell>
                  <Table.Cell>{this.getPercent(row.ret10)}</Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </Container>
    );
  }
}

Performance.propTypes = {
  analytics: PropTypes.object,
  french: PropTypes.bool,
};

Performance.defaultProps = {
  analytics: {},
  french: false,
};

const Container = styled.div`
  min-height: 100%;
  padding: 2rem 2rem 1rem 2rem;
`;
